module.exports = __webpack_public_path__ + "img/it4d-e-samu.4093e301.png";